import {Box} from '@mui/material'
import {map} from 'lodash'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useQuestionActions} from '../../hooks'
import {QuestionItem} from '../../types'
import {ActionDialogWrapper} from '../actionDialog/ActionDialogWrapper'
import {ActionsListItem} from '../actions/ActionsListItem'
import {DefaultAddButton, AddInformationHeader} from '../common'

type Props = {
  question: QuestionItem
}

export const Actions: React.FC<Props> = ({question}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {data: actions} = useQuestionActions(question.id)

  return (
    <Box my={3}>
      <AddInformationHeader title={t('actions.heading')}>
        <ActionDialogWrapper
          connectedTo={question}
          opener={<DefaultAddButton data-test-id="add-action-button" />}
        />
      </AddInformationHeader>
      {map(actions, (a) => (
        <ActionsListItem key={a.id} item={a} />
      ))}
    </Box>
  )
}
